"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var defaultTheme = function defaultTheme(theme) {
  return {
    level: {
      1: {
        borderWidth: theme.border.width[1]
      },
      2: {
        borderWidth: theme.border.width[2]
      }
    },
    appearance: {
      primary: {
        backgroundColor: theme.color.monochrome1["default"],
        color: theme.baseFont.color,
        highlight: {
          primary: {
            borderColor: theme.color.primary1["default"]
          },
          secondary: {
            borderColor: theme.color.secondary1["default"]
          },
          alt1: {
            borderColor: theme.color.secondary4["default"]
          }
        },
        state: {
          warn: {
            borderColor: theme.color.warn["default"]
          },
          error: {
            borderColor: theme.color.error["default"]
          },
          selected: {
            borderColor: theme.color.success["default"]
          },
          info: {
            borderColor: theme.color.info["default"]
          },
          incomplete: {
            borderColor: theme.color.incomplete["default"]
          }
        }
      },
      secondary: {
        backgroundColor: theme.color.monochrome2["default"],
        color: theme.color.monochrome6["default"],
        highlight: {
          primary: {
            borderColor: theme.color.primary1["default"]
          },
          secondary: {
            borderColor: theme.color.secondary1["default"]
          },
          alt1: {
            borderColor: theme.color.secondary4["default"]
          }
        },
        state: {
          warn: {
            borderColor: theme.color.warn["default"]
          },
          error: {
            borderColor: theme.color.error["default"]
          },
          selected: {
            borderColor: theme.color.success["default"]
          },
          info: {
            borderColor: theme.color.info["default"]
          },
          incomplete: {
            borderColor: theme.color.incomplete["default"]
          }
        }
      },
      alt1: {
        backgroundColor: theme.color.monochrome5["default"],
        color: theme.color.monochrome1["default"],
        highlight: {
          primary: {
            borderColor: 'transparent'
          },
          secondary: {
            borderColor: 'transparent'
          },
          alt1: {
            borderColor: 'transparent'
          }
        },
        state: {
          warn: {
            borderColor: 'transparent'
          },
          error: {
            borderColor: 'transparent'
          },
          selected: {
            borderColor: 'transparent'
          },
          info: {
            borderColor: 'transparent'
          },
          incomplete: {
            borderColor: 'transparent'
          }
        }
      },
      alt2: {
        backgroundColor: "linear-gradient(".concat(theme.color.gradient1["default"], ")"),
        color: theme.color.monochrome1["default"],
        highlight: {
          primary: {
            borderColor: 'transparent'
          },
          secondary: {
            borderColor: 'transparent'
          },
          alt1: {
            borderColor: 'transparent'
          }
        },
        state: {
          warn: {
            borderColor: 'transparent'
          },
          error: {
            borderColor: 'transparent'
          },
          selected: {
            borderColor: 'transparent'
          },
          info: {
            borderColor: 'transparent'
          },
          incomplete: {
            borderColor: 'transparent'
          }
        }
      },
      alt3: {
        backgroundColor: "linear-gradient(".concat(theme.color.gradient2["default"], ")"),
        color: theme.color.monochrome1["default"],
        highlight: {
          primary: {
            borderColor: 'transparent'
          },
          secondary: {
            borderColor: 'transparent'
          },
          alt1: {
            borderColor: 'transparent'
          }
        },
        state: {
          warn: {
            borderColor: 'transparent'
          },
          error: {
            borderColor: 'transparent'
          },
          selected: {
            borderColor: 'transparent'
          },
          info: {
            borderColor: 'transparent'
          },
          incomplete: {
            borderColor: 'transparent'
          }
        }
      },
      alt4: {
        backgroundColor: theme.color.primary1["default"],
        color: theme.color.monochrome1["default"],
        highlight: {
          primary: {
            borderColor: 'transparent'
          },
          secondary: {
            borderColor: 'transparent'
          },
          alt1: {
            borderColor: 'transparent'
          }
        },
        state: {
          warn: {
            borderColor: 'transparent'
          },
          error: {
            borderColor: 'transparent'
          },
          selected: {
            borderColor: 'transparent'
          },
          info: {
            borderColor: 'transparent'
          },
          incomplete: {
            borderColor: 'transparent'
          }
        }
      },
      alt5: {
        backgroundColor: theme.color.secondary1["default"],
        color: theme.color.secondary1["default"],
        highlight: {
          primary: {
            borderColor: 'transparent'
          },
          secondary: {
            borderColor: 'transparent'
          },
          alt1: {
            borderColor: 'transparent'
          }
        },
        state: {
          warn: {
            borderColor: 'transparent'
          },
          error: {
            borderColor: 'transparent'
          },
          selected: {
            borderColor: 'transparent'
          },
          info: {
            borderColor: 'transparent'
          },
          incomplete: {
            borderColor: 'transparent'
          }
        }
      }
    }
  };
};
var _default = defaultTheme;
exports["default"] = _default;